import { SearchResultItem } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Alert, Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { t } from '@translations';
import { DocumentCard } from '../content/DocumentCard/DocumentCard';

// STYLES
//---------

const DocumentListBox = styled(Box)<{ nogrid?: string }>`
  display: ${(props) => (props.nogrid === 'true' ? 'flex' : 'grid')};
  flex-direction: column;
  gap: 16px;
  ${breakpoints.up('md')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 1fr;
    gap: 20px;
  }
`;

// TYPES
//-------
export type DocumentListProps = {
  documents?: SearchResultItem[];
  isWorking?: boolean;
  onRemove?: (key: number) => void;
  nogrid?: string;
  showAlert?: boolean;
};

// COMPONENTS
//------------
export const DocumentList = ({
  documents = [],
  isWorking,
  onRemove,
  nogrid,
  showAlert,
}: DocumentListProps) => (
  <DocumentListBox nogrid={nogrid}>
    {documents.map((doc, key) => (
      <DocumentCard
        {...doc}
        isWorking={isWorking}
        key={key}
        onRemove={onRemove ? () => onRemove(key) : undefined}
      />
    ))}
    {documents && documents.length === 0 && showAlert && (
      <Alert severity='info'>{t(TextCodes.Base.NoFiles)}</Alert>
    )}
  </DocumentListBox>
);
